import { call, put, takeEvery } from "redux-saga/effects";
import { fetchOemScans } from "../../api/oemScanApi";
import { OEM_SCAN_CONSTANTS } from "../constants/oemScanConstants";

function* fetchOemScansSaga(action) {
  try {
    const response = yield call(fetchOemScans, action.payload);
    yield put({ type: OEM_SCAN_CONSTANTS.FETCH_OEM_SCANS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: OEM_SCAN_CONSTANTS.FETCH_OEM_SCANS_FAILURE, payload: error.message });
  }
}

function* oemScanSaga() {
  yield takeEvery(OEM_SCAN_CONSTANTS.FETCH_OEM_SCANS_REQUEST, fetchOemScansSaga);
}

export default oemScanSaga;